"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ResponsiveImageProvider = _interopRequireDefault(require("./ResponsiveImageProvider"));
var _default = _ResponsiveImageProvider["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZXNwb25zaXZlSW1hZ2VQcm92aWRlciJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9SZXNwb25zaXZlSW1hZ2VQcm92aWRlci9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVzcG9uc2l2ZUltYWdlUHJvdmlkZXIgZnJvbSAnLi9SZXNwb25zaXZlSW1hZ2VQcm92aWRlcic7XG5cbmV4cG9ydCBkZWZhdWx0IFJlc3BvbnNpdmVJbWFnZVByb3ZpZGVyO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBO0FBQWdFLGVBRWpEQSxtQ0FBdUI7QUFBQSJ9